module.exports = __webpack_public_path__ + "img/ic-paid.e1ad8df2.svg";